import React from 'react';
import { PropTypes } from 'prop-types';
import { Link } from 'react-router-dom';
import { injectIntl } from 'react-intl';

import { ApiService } from 'services';
import LocalisedMessage from 'components/Common/LocalisedMessage';

import ErrorPage from 'components/Errors/ErrorPage';

const NoInternetPage = ({ caption, buttonText, titleTextId }) => {
  const processRetries = () => {
    ApiService.processQueuedPromises();
  };

  return (<ErrorPage type="network" title="Internet Connection Lost" titleTextId={ titleTextId }>
    <LocalisedMessage id={ caption } />
    <div className="buttons-con">
      <div className="action-link-wrap">
        <button type="button" className="btn btn-primary mr" onClick={ processRetries }><LocalisedMessage id={ buttonText } /></button>
        <Link to="/" className="link-button ml"><LocalisedMessage id="connectionStatus.homePageText" /></Link>
      </div>
    </div>
  </ErrorPage>);
};

NoInternetPage.propTypes = {
  caption: PropTypes.string,
  buttonText: PropTypes.string,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired
  }).isRequired,
  titleTextId: PropTypes.string
};

NoInternetPage.defaultProps = {
  caption: 'connectionStatus.content',
  buttonText: 'connectionStatus.buttonText',
  titleTextId: 'connectionStatus.title'
};

export default injectIntl(NoInternetPage);
